<template>
  <div class="skip-to-content-container col-12 px-0 text-center float-left">
      <a class="skip-to-content-link mx-auto" href="javascript:void(0)" @click.prevent="skip" tabindex="0">
        Skip to Main Content
      </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mainId: '',
    };
  },
  methods: {
    skip() {
      // This method presumes we will always have a role="main" element as it is semantically necessary in any web app
      const MAIN = document.querySelector('div[role="main"]');

      if (!MAIN.id) {
        MAIN.id = 'main-content-area';
        MAIN.setAttribute('tabindex', 0);
        this.mainId = 'main-content-area';
      } else {
        this.mainId = `${MAIN.id}`;
        MAIN.setAttribute('tabindex', 0);
      }

      const main = document.getElementById(this.mainId);
      main.focus();
    },
  },
};
</script>

<style scoped>
.skip-to-content-container {
  background:#EEEEEE;
}
.skip-to-content-link {
  display: block;
  text-decoration: underline;
  font-size:0.75rem;
  font-weight: 600 !important;
  height: 0px;
  width: 150px;
  transition: height 0.3s;
  overflow: hidden;
}
.skip-to-content-link:focus {
  height: 30px !important;
  padding: 5px 0 0;
  outline: 5px auto -webkit-focus-ring-color;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SkipToContent.vue?3bf6d418